import { Box } from "@chakra-ui/react"

export const ContentAccordionLeft = ({ children }) => {
  return (
    <Box
      py="10"
      px="12"
      overflowX="auto"
      sx={{
        flex: "0 0 100%",
        "@container (min-width: 1400px)": {
          flex: "1 1 1000px",
          minWidth: "1000px",
        },
      }}
    >
      {children}
    </Box>
  )
}
